import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  GetCourseAssets200,
  GetCourseAssetsParams
} from './types'


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;



/**
 * 주어진 강의 ID에 연결된 모든 자료(학습 자료, 파일 등)의 목록을 페이지네이션하여 조회합니다.
 * @summary 특정 강의의 자료 목록 조회
 */
export const getCourseAssets = (
    courseId: number,
    params?: GetCourseAssetsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCourseAssets200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/courses/${courseId}/assets`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetCourseAssetsQueryKey = (courseId: number,
    params?: GetCourseAssetsParams,) => {
    return [`https://api.ugot.uk/api/courses/${courseId}/assets`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCourseAssetsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getCourseAssets>>, TError = AxiosError<void>>(courseId: number,
    params?: GetCourseAssetsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseAssets>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseAssetsQueryKey(courseId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseAssets>>> = ({ signal }) => getCourseAssets(courseId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(courseId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseAssets>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseAssetsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseAssets>>>
export type GetCourseAssetsInfiniteQueryError = AxiosError<void>

/**
 * @summary 특정 강의의 자료 목록 조회
 */
export const useGetCourseAssetsInfinite = <TData = Awaited<ReturnType<typeof getCourseAssets>>, TError = AxiosError<void>>(
 courseId: number,
    params?: GetCourseAssetsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseAssets>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseAssetsInfiniteQueryOptions(courseId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCourseAssetsQueryOptions = <TData = Awaited<ReturnType<typeof getCourseAssets>>, TError = AxiosError<void>>(courseId: number,
    params?: GetCourseAssetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseAssets>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseAssetsQueryKey(courseId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseAssets>>> = ({ signal }) => getCourseAssets(courseId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(courseId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourseAssets>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseAssets>>>
export type GetCourseAssetsQueryError = AxiosError<void>

/**
 * @summary 특정 강의의 자료 목록 조회
 */
export const useGetCourseAssets = <TData = Awaited<ReturnType<typeof getCourseAssets>>, TError = AxiosError<void>>(
 courseId: number,
    params?: GetCourseAssetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseAssets>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseAssetsQueryOptions(courseId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



